import type { FlowSlotDto } from '@/types/dtos/flows/response/flow.dto';
import { Stack, Typography } from '@mui/material';
import AddBreak from './add-break';
import AddFromLibrary from './add-from-library';
import AddSession from './add-session';
import { useFlowMode } from '../../use-flow-mode';
import { isOrganizeMode } from '@/components/events/helpers/mode.helper';
import { useTranslations } from '@/i18n/use-translations';

export default function Actions({
  offset,
  duration,
  setSelectedSlot,
  onShowForm,
  formDuration,
  showBreak = true,
  /** When false, only “from library” is shown (e.g. end-gap row already has NEW / BREAK). */
  showWizardAndBreak = true,
  addFromLibraryIsUntimed = false,
  addFromLibraryInsertBeforeSlotId,
  /** When true, cluster controls (e.g. empty timed section under hint text) instead of stretching full width. */
  centered = false,
}: {
  offset: number;
  duration?: number;
  setSelectedSlot: (slot?: FlowSlotDto) => void;
  onShowForm?: (slotType?: 'Session' | 'Break') => void;
  formDuration?: number;
  showBreak?: boolean;
  showWizardAndBreak?: boolean;
  addFromLibraryIsUntimed?: boolean;
  addFromLibraryInsertBeforeSlotId?: string;
  centered?: boolean;
}) {
  const mode = useFlowMode();
  const t = useTranslations();
  if (isOrganizeMode(mode)) {
    return (
      <Stack
        spacing={0.5}
        direction="row"
        alignItems="center"
        justifyContent={centered ? 'center' : 'flex-end'}
        sx={{ width: centered ? 'auto' : '100%' }}
      >
        <Typography variant="subtitle2" color="text.disabled" sx={{ textAlign: 'right' }}>
          {t('common.unscheduled')}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack
      spacing={0.5}
      direction="row"
      alignItems="center"
      justifyContent={centered ? 'center' : 'flex-end'}
      sx={{ width: centered ? 'auto' : '100%' }}
    >
      {showWizardAndBreak ? (
        <>
          <AddSession
            duration={duration}
            onShowForm={onShowForm ? () => onShowForm('Session') : undefined}
            formDuration={formDuration}
          />
          {showBreak && (
            <AddBreak
              duration={duration}
              onShowForm={onShowForm ? () => onShowForm('Break') : undefined}
              formDuration={formDuration}
            />
          )}
        </>
      ) : null}
      <AddFromLibrary
        offset={offset}
        duration={duration}
        setSelectedSlot={setSelectedSlot}
        isUntimed={addFromLibraryIsUntimed}
        insertBeforeSlotId={addFromLibraryInsertBeforeSlotId}
      />
    </Stack>
  );
}
